import Icon from "@ant-design/icons";

const BedSvg = () => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 17 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M2.97026 5.9797H14.526V6H16.0111V14H13.0409V10.9797H2.97026V14H0V0H2.97026V5.9797ZM4.54025 4.5V2.5H8.00555V4.5H4.54025Z"
			fill="currentColor"
		/>
	</svg>
);
export const BedIcon = props => <Icon component={BedSvg} {...props} />;
